import { Observable, of, Subscription } from 'rxjs';

import { CatsActionModeEnum, CatsRecordTypeEnum } from '@shared-enums/cats.enum';
import { SapBooleanEnum } from '@shared-enums/sap.enum';

import { ICatRecord } from '../../interfaces/incoming';
import { CatsDb } from '../catsDB';

export class ProductionGroupText {
  private requestInFlight: Subscription;

  constructor(
    public Employeenumber: string,
    public Workdate: string,
    public LongTextstr: boolean | SapBooleanEnum, //TODO: Narrow this down do it's only one type!
    public ZempCreatedBy: string,
    public RecOrder: string,
    public Zmatnr: string,
    public Extdocumentno: string,
    public Statkeyfig: string,
    public ZprdGrpID: string,
    public Counter: string,
  ) {}

  public handleChange(catsDbInstance: CatsDb) {
    let action$: Observable<ICatRecord | undefined>;
    if (this.requestInFlight != null && !this.requestInFlight.closed) {
      this.requestInFlight.unsubscribe();
    }
    if (!this.Counter) {
      action$ = this.createSelf$(catsDbInstance);
    } else if (this.LongTextstr) {
      action$ = this.updateSelf$(catsDbInstance);
    } else {
      // want this logic to run if there IS a counter AND there isn't value in the form.
      // When this happens I know SAP is going to try to "delete" a record and I'm
      // instead preparing it for a new record to be created.
      action$ = this.createSelf$(catsDbInstance);
    }

    this.requestInFlight = action$.subscribe({
      next: (x) => {
        if (x) this.Counter = x.Counter;
      },
      error: (err) => {
        console.error('Error in ProductionGroupText:', err);
      },
    });
  }

  private updateSelf$(catsDbInstance: CatsDb): Observable<ICatRecord> {
    if (this.LongTextstr === true) this.LongTextstr = SapBooleanEnum.True;
    if (this.LongTextstr === false) this.LongTextstr = SapBooleanEnum.False;

    const data = {
      LongTextstr: this.LongTextstr,
      LongTextstr_X: true,
      Counter: this.Counter,
    };
    return catsDbInstance.simpleSingleCats$(CatsActionModeEnum.Update, data);
  }

  private createSelf$(catsDbInstance: CatsDb): Observable<ICatRecord | undefined> {
    if (this.LongTextstr.toString().trim() === '') return of();
    if (this.LongTextstr === true) this.LongTextstr = SapBooleanEnum.True;
    if (this.LongTextstr === false) this.LongTextstr = SapBooleanEnum.False;

    const data = {
      Employeenumber: this.Employeenumber,
      Workdate: this.Workdate,
      Quantity: '1',
      Longtext: true,
      LongTextstr: this.LongTextstr,
      ZempCreatedBy: this.ZempCreatedBy,
      RecOrder: this.RecOrder,
      Zmatnr: this.Zmatnr || 'NCP',
      Extdocumentno: this.Extdocumentno,
      Statkeyfig: this.Statkeyfig,
      ZprdGrpID: this.ZprdGrpID,
      Zrecordtype: CatsRecordTypeEnum.ProductionText,
    };
    return catsDbInstance.simpleSingleCats$(CatsActionModeEnum.Insert, data);
  }
}
